import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { delay, finalize, takeUntil, tap } from 'rxjs/operators';

import {
  ComparisonOperator,
  CreateRegionalScheduledMessageCommand,
  CustomResultOfGetWhiteMessageCalculationsDto,
  GetCountQuery,
  GetRegionalScheduledMessageCalculationQuery,
  GetWhiteMessageCalculationsDto,
  RegionalRecipient,
  SendTypes,
  SmsAggregator,
} from 'src/app/core/api/models';
import {
  BulkServicesService,
  ScheduledMessagesService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { SendDateTimeType } from 'src/app/core/enums/send-date-time-type.enum';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { NumberSeparatorPipe } from '../../../core/pipes/number.separator.pipe';
import { BaseSendSms } from '../base/base-send-sms/base-send-sms.component';
import { SendBalkSmsComponent } from '../send-balk-sms/send-balk-sms.component';
import { SendSmsConfirmationComponent } from '../send-sms-confirmation/send-sms-confirmation.component';
import { TabsDynamicComponent } from './../../../layout/components/tabs-dynamic/tabs-dynamic.component';
import { ZonePostalCodeSmsSendStepInformation } from './models/zone-postal-code-sms-send-step-information';

@Component({
    selector: 'app-send-zone-postal-code-sms',
    templateUrl: './send-zone-postal-code-sms.component.html',
    styleUrls: [
        './send-zone-postal-code-sms.component.scss',
        '../base/base-sending-system.component.scss',
    ],
    standalone: false
})
export class SendZonePostalCodeSmsComponent
  extends SendBalkSmsComponent
  implements OnInit, OnDestroy
{
  tabName: string = 'sendZonePostalCode';
  isSelectedBefore: boolean = false;
  privateNumber: string;
  postalCodesList: number[] = [];
  model: CreateRegionalScheduledMessageCommand = {};
  queries: ZonePostalCodeSmsSendStepInformation[] = [];

  constructor(
    public dynamicTabService: DynamicTabService,
    protected translate: TranslateService,
    public dialogService: DialogService,
    public utilityService: UtilityService,
    protected currentService: ScheduledMessagesService,
    public CD: ChangeDetectorRef,
    public zoneService: ZonesService,
    public bulkService: BulkServicesService,
    protected tabsDynamicComponent: TabsDynamicComponent,
    protected numberSeparatorPipe: NumberSeparatorPipe
  ) {
    super(
      dynamicTabService,
      translate,
      dialogService,
      utilityService,
      currentService,
      CD,
      zoneService,
      bulkService,
      tabsDynamicComponent,
      numberSeparatorPipe
    );
    this.baseCreateGetApiForSend(
      this.currentService,
      'scheduledMessagesCreateRegionalScheduledMessageGet'
    );
  }

  ngOnInit(): void {
    try {
      super.ngOnInit();
      this.pageConfig.title = this.pageVocabs + 'titlePostalCode';
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region inherited member's
  initForm() {
    this.queryForm = new FormGroup({
      stateControl: new FormControl('', Validators.required),
      cityControl: new FormControl(''),
      regionControl: new FormControl(''),
      businessGroupControl: new FormControl(''),
      businessSubGroupControl: new FormControl(''),
      totalSendControl: new FormControl('', Validators.min(1)),
    });
    this.secondQueryForm = new FormGroup({
      //  Validators.max(this.totalMobileCount)
      startFromControl: new FormControl(''),
      countToSendControl: new FormControl(''),
      prefixControl: new FormControl(
        '',
        Validators.pattern('^(?!0)[0-9]{2,6}')
      ),
      postalCodeControl: new FormControl('', Validators.pattern('[0-9]{2,6}')),
      operatorTypeControl: new FormControl(),
      mobileNumberTypeControl: new FormControl('', Validators.required),
      genderControl: new FormControl(''),
      zonePostalCodeControl: new FormControl('', Validators.required),
      isRandomSend: new FormControl(''),
    });
    this.form = new FormGroup({});
  }

  getTotalCount(event) {
    switch (this.mobileNumberOperatorIdOnStep) {
      case SmsAggregator.Irancell:
        this.totalMobileCount = Array.isArray(event)
          ? event.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.mtnCount,
              0
            )
          : 0;
        break;
      case SmsAggregator.MCI:
        this.totalMobileCount = Array.isArray(event)
          ? event.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.mciCount,
              0
            )
          : 0;
        break;
      case SmsAggregator.Rightel:
        this.totalMobileCount = Array.isArray(event)
          ? event.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.rightelCount,
              0
            )
          : 0;
        break;
      case SmsAggregator.Other:
        this.totalMobileCount = Array.isArray(event)
          ? event.reduce(
              (accumulator, currentValue) =>
                accumulator + currentValue.otherCount,
              0
            )
          : 0;
        break;
    }
  }

  selectedItemsChanged(event: any, fieldName: string) {
    try {
      this.checkValidations(fieldName);
      if (fieldName == 'postalCodesList') {
        this[fieldName] = event.map((items) => items.postalCode);
      } else this[fieldName] = event;

      if (event == null && fieldName == 'businessGroupId') return;

      // if (!this.isSelectedBefore) {
      //   this.calculateCountLoading = false;
      //   this.getTotalCount(event)

      //   this.smsStartFromOnStep = 1;
      //   this.smsCountToSendOnStep = this.totalMobileCount;
      //   if (this.totalMobileCount == 0) this.smsStartFromOnStep = 0;
      //   this.isStepTotalItemCountCalculated = true;
      // }
      // else
      this.calculateStepTotalItemCount();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  calculateStepTotalItemCount(changeInputs: boolean = true) {
    try {
      if (this.calculateCountLoading) return;
      this.calculateCountLoading = true;

      this.totalMobileCount = 0;
      if (changeInputs) {
        this.smsStartFromOnStep = 0;
        this.smsCountToSendOnStep = this.totalMobileCount;
      }

      let model: GetCountQuery = {
        comparisonObjects: [],
        orders: null,
      };
      if (this.stateId && this.stateId != null) {
        model.comparisonObjects.push({
          field: 'StateId',
          operator: ComparisonOperator.EqualTo,
          value: this.stateId.toString(),
        });
      }
      if (this.cityId && this.cityId != null) {
        model.comparisonObjects.push({
          field: 'CityId',
          operator: ComparisonOperator.EqualTo,
          value: this.cityId.toString(),
        });
      }
      if (this.regionId && this.regionId != null) {
        model.comparisonObjects.push({
          field: 'AreaId',
          operator: ComparisonOperator.EqualTo,
          value: this.regionId.toString(),
        });
      }
      if (this.businessGroupId && this.businessGroupId != null) {
        model.comparisonObjects.push({
          field: 'GuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessGroupId.toString(),
        });
      }
      if (this.businessSubGroupId && this.businessSubGroupId != null) {
        model.comparisonObjects.push({
          field: 'SubGuildId',
          operator: ComparisonOperator.EqualTo,
          value: this.businessSubGroupId.toString(),
        });
      }
      if (this.mobileNumberOperatorIdOnStep != null) {
        model.comparisonObjects.push({
          field: 'MobileOperator',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberOperatorIdOnStep.toString(),
        });
        this.isSelectedBefore = true;
      }
      if (this.mobileNumberStartWith.length > 0) {
        let fldName = 'Mobile';
        model.comparisonObjects.push({
          field: fldName,
          operator: ComparisonOperator.StartsWith,
          value: '98' + this.mobileNumberStartWith,
        });
        this.isSelectedBefore = true;
      }
      if (this.mobileNumberTypeOnStep != null) {
        model.comparisonObjects.push({
          field: 'SimType',
          operator: ComparisonOperator.EqualTo,
          value: this.mobileNumberTypeOnStep.toString(),
        });
        this.isSelectedBefore = true;
      } else {
        //here we return to force the user to select a simType
        this.dialogService.openDialog({
          message: this.translate.instant(
            this.errorsVocab + 'mostSelectAtLeastSimType'
          ),
          title: this.translate.instant('common.error'),
          status: DialogStatus.error,
        });
        this.calculateCountLoading = false;
        return;
      }
      if (this.gender != null) {
        model.comparisonObjects.push({
          field: 'GenderType',
          operator: ComparisonOperator.EqualTo,
          value: this.gender.toString(),
        });
        this.isSelectedBefore = true;
      }
      model.postalCodesList = this.postalCodesList;

      this.bulkService
        .bulkServicesGetCount({ body: model })
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(
            () => ((this.loading = false), (this.calculateCountLoading = false))
          )
        )
        .subscribe((count) => {
          this.calculateCountLoading = false;
          this.totalMobileCount = count?.data;
          if (changeInputs) {
            this.smsStartFromOnStep = 1;
            this.smsCountToSendOnStep = this.totalMobileCount;
            if (this.totalMobileCount == 0) this.smsStartFromOnStep = 0;
          }
        });

      this.isStepTotalItemCountCalculated = true;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#region api

  //calculation
  scheduledMessageCalculationsApi(
    model: GetRegionalScheduledMessageCalculationQuery
  ) {
    this.unSubs();
    this.loading = true;
    this.calcLoading = true;

    this.currentService
      .scheduledMessagesGetRegionalScheduledMessageCalculation({ body: model })
      .pipe(
        delay(500),
        tap((res: CustomResultOfGetWhiteMessageCalculationsDto) => {
          if (res.isSucceed) this.onConfirmation(res?.data);
        }),
        this.basePipeOperators(),
        finalize(() => (this.calcLoading = false))
      )
      .subscribe();
  }

  //create
  createScheduledMessageBulkApi(
    requestModel: CreateRegionalScheduledMessageCommand
  ) {
    this.unSubs();
    this.loading = true;
    this.sendLoading = true;

    this.currentService
      .scheduledMessagesCreateRegionalScheduledMessagePost({
        body: requestModel,
      })
      .pipe(
        this.basePipeOperators(),
        finalize(() => (this.sendLoading = false))
      )
      .subscribe((result) => {
        try {
          this.apiNotificationService.notifyMessage({
            result,
            mode: 'matDialog',
          });
          if (result.isSucceed) {
            this.refreshPage();
            this.onSuccess();
          }
        } catch (error) {
          this.loggerService.logError(
            this.tagName,
            error,
            EventTypes.sendingSystem
          );
        }
      });
  }

  onConfirmation(model: GetWhiteMessageCalculationsDto) {
    try {
      this.unSubs();
      let data = {
        model: model,
        smsCount: this.smsCount,
        sendType: SendTypes.Bulk,
        privateNumber: this.privateNumber,
      };

      const modalResult = this.dialogService.openModal({
        component: SendSmsConfirmationComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((confirm) => {
          if (confirm) {
            if (!this.formPageConfig.isEditMode)
              this.createScheduledMessageBulkApi(this.model);
            else this.updateScheduledMessageBulkApi();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  //#endregion
  getRecipients(recipientsJson: string) {
    try {
      const recipients = JSON.parse(recipientsJson);
      recipients.forEach((item, index) => {
        this.queries[index] = {};

        this.cityId = item?.cityId;
        this.stateId = item?.stateId;
        this.regionId = item?.areaId;
        this.businessGroupId = item?.guildId;
        this.businessSubGroupId = item?.subGuildId;

        this.calculateStepTotalItemCount();

        // this.queries[index].totalMobileCount = this.totalMobileCount;
        if (item?.cityId) this.queries[index].cityId = item?.cityId;
        if (item?.stateId) this.queries[index].stateId = item?.stateId;
        if (item?.areaId) this.queries[index].regionId = item?.areaId;
        if (item?.genderTye) this.queries[index].gender = item?.genderTye;
        if (item?.fromIndex)
          this.queries[index].smsStartFromOnStep = item?.fromIndex;
        if (item?.count) this.queries[index].smsCountToSendOnStep = item?.count;
        if (item?.guildId) this.queries[index].businessGroupId = item?.guildId;
        if (item?.subGuildId)
          this.queries[index].businessSubGroupId = item?.subGuildId;
        if (item?.zipCode)
          this.queries[index].postalCodesList = item?.zipCode.toString();
        if (item?.preFix)
          this.queries[index].mobileNumberStartWith = [
            '98',
            '9898',
            '989898',
          ].includes(item.preFix.toString())
            ? ''
            : item?.preFix.toString();
        if (item?.simType)
          this.queries[index].mobileNumberTypeOnStep = item?.simType;
        if (item?.aggregatorType)
          this.queries[index].mobileOperatorIdOnStep = item?.aggregatorType;

        let itemForGenerateText: ZonePostalCodeSmsSendStepInformation =
          this.queries[index];

        itemForGenerateText.mobileNumberStartWith =
          '98' +
          (['98', '9898', '989898'].includes(item.preFix.toString())
            ? ''
            : item?.preFix.toString());

        itemForGenerateText.Text = '';

        const timeOut = setTimeout(() => {
          this.queries[index].Text = this.stepItemToText(itemForGenerateText);
          this.model.regionalRecipients[index].description =
            this.queries[index]?.Text;
          clearTimeout(timeOut);
        }, 1000);
      });

      this.calculateTotalSmsMostSent();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  stepItemToText(item: ZonePostalCodeSmsSendStepInformation): string {
    try {
      let result: string = '';
      let separator = ' ';
      const selStates = this.selStates();
      if (item.stateId && selStates?.items) {
        for (let index = 0; index < selStates?.items.length; index++) {
          if (selStates?.items[index].id == item.stateId)
            result +=
              this.translate.instant('common.state') +
              separator +
              selStates?.items[index].name;
        }
        result += separator;
      }
      const selCities = this.selCities();
      if (item.cityId && selCities?.items) {
        for (let index = 0; index < selCities.items.length; index++) {
          if (selCities.items[index].id == item.cityId)
            result +=
              this.translate.instant('common.city') +
              separator +
              selCities.items[index].name;
        }
        result += separator;
      }
      const selRegions = this.selRegions();
      if (item.regionId && selRegions?.items) {
        for (let index = 0; index < selRegions.items.length; index++) {
          if (selRegions.items[index].id == item.regionId)
            result +=
              this.translate.instant(this.fields + 'region') +
              separator +
              selRegions.items[index].name;
        }
        result += separator;
      }
      const selBusinessGroups = this.selBusinessGroups();
      if (item.businessGroupId && selBusinessGroups?.items) {
        for (
          let index = 0;
          index < selBusinessGroups.items.length;
          index++
        ) {
          if (selBusinessGroups.items[index].id == item.businessGroupId)
            result +=
              this.translate.instant(this.fields + 'businessGroup') +
              separator +
              selBusinessGroups.items[index].name;
        }
        result += separator;
      }
      const selBusinessSubGroups = this.selBusinessSubGroups();
      if (item.businessSubGroupId && selBusinessSubGroups?.items) {
        for (
          let index = 0;
          index < selBusinessSubGroups.items.length;
          index++
        ) {
          if (
            selBusinessSubGroups.items[index].id == item.businessSubGroupId
          )
            result +=
              this.translate.instant(this.fields + 'businessSubGroup') +
              separator +
              selBusinessSubGroups.items[index].name;
        }
        result += separator;
      }
      const matNumberType = this.matNumberType();
      if (item.mobileNumberTypeOnStep && matNumberType?.options) {
        let ar = matNumberType.options.toArray();
        for (let index = 0; index < ar.length; index++) {
          if (ar[index].value == item.mobileNumberTypeOnStep)
            result +=
              this.translate.instant(this.fields + 'mobileType') +
              separator +
              ar[index].getLabel();
        }
        result += separator;
      }
      const matOperatorType = this.matOperatorType();
      if (item.mobileOperatorIdOnStep && matOperatorType?.items) {
        let ar = matOperatorType?.items;
        for (let index = 0; index < ar.length; index++) {
          if (ar[index].id == item.mobileOperatorIdOnStep)
            result +=
              this.translate.instant(this.fields + 'operatorType') +
              separator +
              ar[index].name;
        }
        result += separator;
      }
      if (item.postalCodesList && item.postalCodesList.length > 0) {
        result +=
          this.translate
            .instant(this.fields + 'postalCodeContains')
            .replaceAll('%s', item.postalCodesList.toString()) + separator;
      }
      if (item.mobileNumberStartWith && item.mobileNumberStartWith.length > 0) {
        result +=
          this.translate
            .instant(this.fields + 'asIfStartWith')
            .replaceAll('%s', item.mobileNumberStartWith) + separator;
      }
      if (item.smsStartFromOnStep == -1) {
        result += this.translate.instant('common.isRandomSend') + separator;
      }
      if (item.totalMobileCount)
        result +=
          this.translate.instant(this.fields + 'totalMobileNumber') +
          separator +
          this.numberSeparatorPipe.transform(item.totalMobileCount);

      result = result.replaceAll('  ', ' ');
      return result;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  createModel() {
    try {
      let requestModel: CreateRegionalScheduledMessageCommand = {};

      requestModel = this.model;
      requestModel.regionalRecipients = [];
      //#region generate queries for bulk send
      this.queries.forEach(function (query) {
        let serverQuery: RegionalRecipient = {};
        if (
          query.mobileNumberTypeOnStep != null &&
          query.mobileNumberTypeOnStep != null
        )
          serverQuery.simType = query.mobileNumberTypeOnStep;
        if (
          query.mobileOperatorIdOnStep != null &&
          query.mobileOperatorIdOnStep != null
        )
          serverQuery.aggregatorType = query.mobileOperatorIdOnStep;
        if (query.businessGroupId && query.businessGroupId != null)
          serverQuery.guildId = query.businessGroupId;
        if (query.businessSubGroupId && query.businessSubGroupId != null)
          serverQuery.subGuildId = query.businessSubGroupId;
        if (query.stateId && query.stateId != null)
          serverQuery.stateId = query.stateId;
        if (query.cityId && query.cityId != null)
          serverQuery.cityId = query.cityId;
        if (query.regionId && query.regionId != null)
          serverQuery.areaId = query.regionId;
        if (query.postalCodesList && query.postalCodesList.length > 0)
          serverQuery.postalCodes = query.postalCodesList;
        if (query.smsStartFromOnStep)
          serverQuery.fromIndex = query.smsStartFromOnStep;
        if (query.smsCountToSendOnStep)
          serverQuery.count = query.smsCountToSendOnStep;
        if (query.gender && query.gender != null)
          serverQuery.genderTye = query.gender;
        if (
          query.mobileNumberStartWith &&
          query.mobileNumberStartWith.length > 0
        )
          serverQuery.preFix = Number.parseInt(query.mobileNumberStartWith);

        if (query.Text && query.Text != null)
          serverQuery.description = query.Text;
        requestModel.regionalRecipients?.push(serverQuery);
      });
      //#endregion

      this.model = requestModel;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  createRegionQuery() {
    try {
      //this.calculateStepTotalItemCount(false);
      //first most check total mobile number and number of sms most sent
      if (!this.secondQueryForm.valid) {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(
            this.errorsVocab + 'pleaseEnterValidDateForSend'
          ),
          status: DialogStatus.error,
        });
        return;
      }
      if (this.totalMobileCount > 0) {
        let item: ZonePostalCodeSmsSendStepInformation = {
          businessGroupId: this.businessGroupId,
          businessSubGroupId: this.businessSubGroupId,
          cityId: this.cityId,
          mobileNumberStartWith: '98' + this.mobileNumberStartWith,
          mobileNumberTypeOnStep: this.mobileNumberTypeOnStep,
          mobileOperatorIdOnStep: this.mobileNumberOperatorIdOnStep,
          postalCodesList: this.postalCodesList,
          regionId: this.regionId,
          smsCountToSendOnStep: this.smsCountToSendOnStep,
          smsStartFromOnStep: !this.isRandomSend ? this.smsStartFromOnStep : -1,
          stateId: this.stateId,
          totalMobileCount: this.totalMobileCount,
          Text: '',
          gender: this.gender,
        };
        item.Text = this.stepItemToText(item);
        this.description = item.Text;
        if (
          item.smsStartFromOnStep + item.smsCountToSendOnStep - 1 >
          item.totalMobileCount
        ) {
          this.dialogService.openDialog({
            title: this.translate.instant('common.error'),
            message: this.translate.instant(
              this.errorsVocab + 'smsCountBiggerThanTotal'
            ),
            status: DialogStatus.error,
          });
          return;
        }

        this.queries.push(item);
        // this.model.bulkRecipients.push(item)
        //empty fields after add new query
        this.resetOtherData();
        this.calculateStepTotalItemCount();

        this.calculateTotalSmsMostSent();
        this.CD.detectChanges();
      } else {
        this.dialogService.openDialog({
          title: this.translate.instant('common.error'),
          message: this.translate.instant(this.errorsVocab + 'emptyRegion'),
          status: DialogStatus.error,
        });
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  getBaseSendSmsModel(baseModel: BaseSendSms) {
    try {
      this.smsCount = baseModel.smsCount;
      this.model.smsBody = baseModel.finalSmsBody;
      this.model.senderNumberId = baseModel.senderNumberId;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;
      this.model.description = baseModel.description;
      this.model.receivers = baseModel.zipExtraReceivers;

      this.handleVoiceMessage(
        baseModel.isCanSendVoice,
        baseModel.voiceMessageDetails
      );

      this.handleSocialMediaMessage(
        baseModel.isCanSendSocialMedia,
        baseModel.socialMediaMessageDetails
      );

      if (baseModel.campaignId) this.model.campaignId = baseModel.campaignId;
      if (baseModel.recipientsJson)
        this.getRecipients(baseModel.recipientsJson);

      //direct
      this.model.sendDateTimeChecked =
        baseModel.sendDateTimeType == SendDateTimeType.DateTime ||
        baseModel.sendDateTimeType == undefined
          ? true
          : false;
      this.model.sendDateTime = baseModel.directSendDateTime;
      // period
      this.model.sendPeriodChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Period ? true : false;
      this.model.periodStart = baseModel.periodicSendStartDateTime;
      this.model.periodEnd = baseModel.periodicSendEndDateTime;
      this.model.periodText = baseModel.gradualPeriodText;
      this.model.periodTypeValue = baseModel.periodTypeValue;
      this.model.isSendWhiteList = baseModel.isSendWhiteList;
      this.model.isFlashSms = baseModel.isFlashSms;
      // gradual
      this.model.gradualChecked =
        baseModel.sendDateTimeType == SendDateTimeType.Gradual ? true : false;
      this.model.gradualStart = baseModel.gradualSendDateTime;
      this.model.gradualPageSize = baseModel.gradualPageSize;
      this.model.gradualPeriodText = baseModel.gradualPeriodText;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;

      this.createModel();

      //create
      this.scheduledMessageCalculationsApi({
        smsBody: this.model.smsBody,
        regionalRecipients: this.model.regionalRecipients,
        senderNumberId: this.model.senderNumberId,
        voiceMessageId: this.model?.voiceMessageDetails?.voiceMessageId || null,
        receivers: this.model.receivers,
        socialMediaDetails: this.model?.socialMediaDetails || null,
      });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.sendingSystem
      );
    }
  }

  resetOtherData() {
    this.mobileNumberOperatorIdOnStep = SmsAggregator.MCI;
    this.mobileNumberStartWith = '';
    this.gender = 0;
    this.postalCode = '';
    this.postalCodesList = [];
    this.regionId = null;
    this.businessGroupId = null;
    this.businessSubGroupId = null;
  }

  getPrivateNumber(number: string) {
    this.privateNumber = number;
  }
}
